const onlineSalesAction = {
    SET_STATE: 'onlineSales/SET_STATE',
    HANDLE_STATE: 'onlineSales/HANDLE_STATE',
    SUBMISSION: 'onlineSales/SUBMISSION',
    GET_PRODUCTS_AVAILABILITY: 'onlineSales/GET_PRODUCTS_AVAILABILITY',
    GET_PRODUCTS_DAYS_AVAILABILITY: 'onlineSales/GET_PRODUCTS_DAYS_AVAILABILITY',

    ADD_TO_CART: 'onlineSales/ADD_TO_CART',
    DELETE_ITEM_CART: 'onlineSales/DELETE_ITEM_CART',
    UPDATE_ITEM_CART: 'onlineSales/UPDATE_ITEM_CART',
    CREATE_ORDER: 'onlineSales/CREATE_ORDER',
    GET_BRANDS: 'onlineSales/GET_BRANDS',
    GET_OUTLET: 'onlineSales/GET_OUTLET',

    GET_HISTORY_TRANSACTIONS: 'onlineSales/GET_HISTORY_TRANSACTIONS',
    GET_HISTORY_TRANSACTION_DETAIL: 'onlineSales/GET_HISTORY_TRANSACTION_DETAIL',
    CREATE_ORDER_SUBSCRIPTION: 'onlineSales/CREATE_ORDER_SUBSCRIPTION',

    GET_LOYALTY_TIER: 'onlineSales/GET_LOYALTY_TIER',
    GET_AVAILABLE_REWARDS: 'onlineSales/GET_AVAILABLE_REWARDS',
    GET_POINT_HISTORY: 'onlineSales/GET_POINT_HISTORY',
    GET_REDEEM_HISTORY: 'onlineSales/GET_REDEEM_HISTORY',
    TRIGGER_REDEEM: 'onlineSales/TRIGGER_REDEEM',
};

export default onlineSalesAction;
